export default __webpack_public_path__ + "static/media/featSportMb.9ce75a09.png";